import type { Permission, Role, RoleCreatePayload, RoleUpdatePayload } from "@/types/role";

import { api, unwrap } from "./axiosConfig";

const ws = (id: number) => `/api/v1/workspaces/${id}`;

export const roleService = {
  list(workspaceId: number): Promise<Role[]> {
    return unwrap(api.get(`${ws(workspaceId)}/roles`));
  },
  listPermissions(workspaceId: number): Promise<Permission[]> {
    return unwrap(api.get(`${ws(workspaceId)}/permissions`));
  },
  create(workspaceId: number, payload: RoleCreatePayload): Promise<Role> {
    return unwrap(api.post(`${ws(workspaceId)}/roles`, payload));
  },
  update(workspaceId: number, roleId: number, payload: RoleUpdatePayload): Promise<Role> {
    return unwrap(api.patch(`${ws(workspaceId)}/roles/${roleId}`, payload));
  },
  remove(workspaceId: number, roleId: number): Promise<void> {
    return api.delete(`${ws(workspaceId)}/roles/${roleId}`).then(() => undefined);
  },
};

export const grantService = {
  update(
    workspaceId: number,
    grantId: number,
    payload: {
      role_id?: number;
      scope?: string;
      organization_ids?: number[];
      client_ids?: number[];
    },
  ): Promise<void> {
    return api
      .patch(`${ws(workspaceId)}/access-grants/${grantId}`, payload)
      .then(() => undefined);
  },
};
